import type { IconData } from '@stacksjs/iconify-core'

export const buttonPlayCircleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M1.5 24c0 12.426 10.074 22.5 22.5 22.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5S1.5 11.574 1.5 24\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M20.51 14.221c-2.436-.97-4.724.496-5.076 3.094A50 50 0 0 0 15 24c0 2.67.195 4.925.434 6.685c.352 2.598 2.64 4.064 5.076 3.093c1.534-.61 3.547-1.528 6.137-2.903c2.446-1.3 4.378-2.463 5.878-3.446c2.653-1.74 2.653-5.118 0-6.858c-1.5-.984-3.432-2.147-5.878-3.446c-2.59-1.376-4.603-2.293-6.137-2.904\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default buttonPlayCircleFlat
